module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wordy"
  }, [_c('p', [_vm._v(_vm._s(_vm.basics.summary))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.works), function(work) {
    return _c('section', [_c('h2', [_vm._v(_vm._s(work.position))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(work.startDate) + " - " + _vm._s(work.endDate))]), _vm._v(" "), _c('p', [_vm._v("Company: " + _vm._s(work.company))]), _vm._v(" "), _c('ul', _vm._l((work.highlights), function(highlight) {
      return _c('li', [_vm._v(_vm._s(highlight))])
    }))])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.education), function(degree) {
    return _c('section', [_c('span', [_vm._v(_vm._s(degree.startDate) + " " + _vm._s(degree.endDate) + " - ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(degree.area))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(degree.institution))])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('section', [_c('h2', [_vm._v(" Role: " + _vm._s(project.rol))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.startDate) + " - " + _vm._s(project.endDate))]), _vm._v(" "), _c('p', [_vm._v("Project name: " + _vm._s(project.name))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(project.description))]), _vm._v(" "), _c('p', [_vm._v("Client: " + _vm._s(project.client.country) + " - " + _vm._s(project.client.name))]), _vm._v(" "), _c('span', [_vm._v("Technologies:")]), _vm._v(" "), _vm._l((project.technologies), function(tech, index) {
      return (project.technologies.length - 1 == index) ? _c('span', [_vm._v("\n      " + _vm._s(tech) + ".\n    ")]) : _c('span', [_vm._v(_vm._s(tech) + ", ")])
    }), _vm._v(" "), _c('p', [_vm._v("Team Size: " + _vm._s(project.teamSize))]), _vm._v(" "), _c('ul', _vm._l((project.highlights), function(highlight) {
      return _c('li', [_vm._v(_vm._s(highlight))])
    }))], 2)
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.nfpProjects), function(project) {
    return _c('section', [_c('h2', [_vm._v("Project name: " + _vm._s(project.name))]), _vm._v(" "), _c('p', [_vm._v("Description: " + _vm._s(project.description))]), _vm._v(" "), _c('p', [_vm._v("Url: " + _vm._s(project.url))]), _vm._v(" "), _c('span', [_vm._v("Technologies:")]), _vm._v(" "), _vm._l((project.technologies), function(tech, index) {
      return (project.technologies.length - 1 == index) ? _c('span', [_vm._v("\n      " + _vm._s(tech) + ".\n    ")]) : _c('span', [_vm._v(_vm._s(tech) + ", ")])
    })], 2)
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', [_c('ul', _vm._l((_vm.interests), function(interest) {
    return _c('li', [_vm._v(_vm._s(interest))])
  }))])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Experience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Education")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Professional Projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Not For Profit Projects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-section"
  }, [_c('h1', [_vm._v("Personal Interests")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b70a35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wordy.vue
// module id = 20
// module chunks = 0